<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    v-model="issueDate"
                    label="Issue Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockTransfer.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="stockTransfer.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockTransfer.id && (user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN')">
                <v-autocomplete
                  v-model="stockTransfer.status"
                  :items="adminStatusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="status == 'FINISHED'? true : status == 'CANCEL'? true : false"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12 v-if="stockTransfer.id && user.role.roleName == 'WAREHOUSE_MANAGER'">
                <v-autocomplete
                  v-model="stockTransfer.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="status == 'FINISHED'? true : status == 'CANCEL'? true : false"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>

              <v-flex sm12 v-if="user.role.roleName == 'WAREHOUSE_MANAGER'">
                <v-autocomplete
                  label="From Warehouse Name"
                  v-model="stockTransfer.fromWarehouseName"
                  :items="stockTransfer.fromWarehouseName"
                  color="blue-grey lighten-2"
                  type="text"
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  :readonly="true"
                ></v-autocomplete>
              </v-flex>

              <v-flex sm12 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
                <v-autocomplete
                  v-model="stockTransfer.fromWarehouseName"
                  :items="warehouseList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="From Warehouse"
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  :readonly="status != 'DRAFT'"
                  :rules="[() => !!stockTransfer.fromWarehouseName || 'From warehouse is required.',
                  () => stockTransfer.fromWarehouseName != stockTransfer.toWarehouseName || 'To and From warehouse must be different.']"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="stockTransfer.toWarehouseName"
                  :items="warehouseList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="To Warehouse"
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  :rules="[() => !!stockTransfer.toWarehouseName || 'To warehouse is required.',
                  () => stockTransfer.fromWarehouseName != stockTransfer.toWarehouseName || 'To and From warehouse must be different.']"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="stockTransfer.description"
                  type="text"
                  :rules="rules.descriptionRules"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockTransfer.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockTransfer.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="stockTransfer.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockTransfer.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockTransfer.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="stockTransfer.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addStockTransferItem()"
                    :disabled="status != 'DRAFT'"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs3>Code</v-flex>
                  <v-flex xs3>Name</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs1>Qty</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(stockTransferItem, index) in stockTransfer.stockTransferItems"
                  :key="index"
                >
                  <v-flex xs3>
                    <v-text-field
                      v-if="status == 'DRAFT'"
                      placeholder="Select the code"
                      v-model="stockTransferItem.productCode"
                      @click.stop="showProducts(), selectedIndex = index"
                      :rules="rules.codeRules"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      placeholder="Select the code"
                      v-model="stockTransferItem.productCode"
                      :rules="rules.codeRules"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="stockTransferItem.productName"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      placeholder="Name"
                      readonly
                      :rules="rules.productNameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="stockTransferItem.factorUnitName"
                      :items="stockTransferItem.productUnits"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      placeholder="Select"
                      :rules="rules.unitRules"
                      :readonly="status != 'DRAFT'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="stockTransferItem.qty"
                      type="number"
                      min="0"
                      :rules="rules.qtyRules"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      name="remark"
                      placeholder="Remark"
                      v-model="stockTransferItem.remark"
                      type="text"
                      :rules="rules.remarkRules"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removeStockTransferItem(index, stockTransferItem.id)"
                      :disabled=" status != 'DRAFT' || index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" :disabled="btnDisabled" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    @click="onSave"
                    :disabled="btnDisabled || saveLoading"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setProduct(props.item.code, selectedIndex), showProductListDialog = !showProductListDialog"
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">{{ props.item.productGroup.name }}</td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { stockTransferService } from "../../services/stock-transfer-service";
import { warehouseService } from "../../services/warehouse-service";
import { StockTransfer } from "../../models/model";
import { StockTransferItem } from "../../models/model";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { StockTransferFormRules } from "../../helpers/validation-rules";
import { productService } from "../../services/product-service";
export default {
  name: "StockTransferDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    btnDisabled: false,
    breadcrumbs: [
      {
        text: "StockTransfer",
        disabled: false,
        to: "stock-transfers"
      },
      {
        text: "StockTransfer Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    warehouseId: "",
    fromWarehouseId: "",
    toWarehouseId: "",
    issueDate: "",
    fromWarehouseName: "",
    responseError: "",
    messageDialogBox: false,
    stockTransfer: new StockTransfer(),
    oldStockTransfer: new StockTransfer(),
    stockTransferItem: new StockTransferItem(),
    saveLoading: false,
    statusList: [],
    adminStatusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "DELIVERY", value: "DELIVERY" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    warehouseList: [],
    productList: [],
    status: "DRAFT",
    rules: new StockTransferFormRules(),
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" }
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: ""
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true
    }
  },
  created() {
    if (this.user.role.roleName == "WAREHOUSE_MANAGER") {
      this.stockTransfer.fromWarehouseName = this.user.warehouseName;
      this.warehouseId = this.user.warehouseId;
    }
    this.fromWarehouseName = this.user.warehouseName;
    this.getWarehouses();

    const id = this.$route.params.id;
    if (id == "new") {
      // new stockTransfer
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.addStockTransferItem();
    } else {
      this.getStockTransferDetail(id);
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        // convert to millisecond
        this.stockTransfer.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );

        stockTransferService
          .saveStockTransfer(this.stockTransfer)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },
    getStockTransferDetail(id) {
      stockTransferService
        .getStockTransferDetail(id)
        .then(res => {
          this.stockTransfer = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.stockTransfer.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.stockTransfer.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.fromWarehouseId = res.data.fromWarehouseId;
          this.toWarehouseId = res.data.toWarehouseId;
          if (this.fromWarehouseId == this.warehouseId) {
            this.statusList.push("DRAFT", "DELIVERY", "CANCEL");
            if (res.data.status == "FINISHED") {
              this.statusList.push("FINISHED");
            }
          } else if (this.fromWarehouseId != this.warehouseId) {
            this.statusList.push("FINISHED");
            if (res.data.status != "FINISHED") {
              this.statusList.push(res.data.status);
            }
          }

          this.issueDate = commonService.millisecondToDate(
            this.stockTransfer.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.status = this.stockTransfer.status;
          if(this.status == "FINISHED"){
            this.btnDisabled = true;
          }
          // deep copy
          this.oldStockTransfer = JSON.parse(JSON.stringify(res.data));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getWarehouses() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";

      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.stockTransfer.id) {
        this.stockTransfer = new StockTransfer();
        this.addStockTransferItem();
      } else {
        this.stockTransfer = Object.assign({}, this.oldStockTransfer);
      }
    },
    goBack() {
      this.$router.push("/stock-transfers");
    },
    addStockTransferItem() {
      // deep copy
      let sti = JSON.parse(JSON.stringify(this.stockTransferItem));

      this.stockTransfer.stockTransferItems.push(sti);
    },
    removeStockTransferItem(index, stockTransferItemId) {
      if (stockTransferItemId) {
        // add delete stockTransfer item id
        if (!this.stockTransfer.deleteStockTransferItemIds) {
          this.stockTransfer.deleteStockTransferItemIds = [];
        }
        this.stockTransfer.deleteStockTransferItemIds.push(stockTransferItemId);
      }
      this.$delete(this.stockTransfer.stockTransferItems, index);
    },
    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.stockTransfer.stockTransferItems[index].productCode = product.code;
      this.stockTransfer.stockTransferItems[index].productName = product.name;
      this.stockTransfer.stockTransferItems[index].factorUnitName = "";
      this.stockTransfer.stockTransferItems[index].productUnits =
        product.productUnits;
      this.stockTransfer.stockTransferItems[index].qty = 0;
      this.stockTransfer.stockTransferItems[index].remark = "";
    }
  }
};
</script>

